/** Default Agilysys wordmark when a product has no dedicated logo URL. */
export const DEFAULT_PRODUCT_LOGO_URL =
  "https://www.agilysys.com/en/wp-content/uploads/2024/09/Agilysys-Logo-v1.png";

export const getImageForProperty = (productId: number): string => {
  switch (productId) {
    case 1:
      return "https://spa.agilysys.com/Spa/assets/images/spa_logo.png";
    case 2:
      return "https://golf.agilysys.com/Golf/assets/images/Golf_Logo.png";
    case 3:
      return "https://retail-ui-sales.onagilysys.com/Retail/assets/images/logo.png";
    case 5:
      return "https://salesandcatering.agilysys.com/snc/assets/images/logo-login.png";
    case 6:
      return "https://visualone.onagilysys.com/pms/assets/images/logo_old1.png";
    case 12:
      return "https://d9hhrg4mnvzow.cloudfront.net/discover.agilysys.com/sem/agilysys-reserve/e05e3b22-agilysys-logo-only-pms-376-and-2925-white-agilysys-for-dark-background_109o062000000000000028.png";
    case 13:
      return "https://d9hhrg4mnvzow.cloudfront.net/discover.agilysys.com/sem/agilysys-reserve/e05e3b22-agilysys-logo-only-pms-376-and-2925-white-agilysys-for-dark-background_109o062000000000000028.png";
    default:
      return DEFAULT_PRODUCT_LOGO_URL;
  }
};
